import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CommentItem } from "models/propTypes/commentViewPropTypes";
import { User } from "models/propTypes/userProfilePropTypes";
import { FileItem } from "models/utilTypes/fileUtilsTypes";
import { getFirstName } from "utils/helpers/getFirstName";

export function toSupportCommentItems(
  comments: WintSuperkollAPIModel.SupportComment[] | undefined,
  noMessagePlaceholders: string[]
): CommentItem[] {
  return (
    comments?.map<CommentItem>((comment) => ({
      id: comment.id,
      message: comment.message ?? "",
      isPlaceholderMessage: !!comment.message && noMessagePlaceholders.includes(comment.message),
      from: new User(comment.user!.id, comment.fromWint ? getFirstName(comment.user!.name) : comment.user!.name, true),
      date: comment.created,
      attachments: comment.attachments!.map<FileItem>((file) => ({
        id: file.id,
        name: file.fileName,
        sizeInBytes: file.fileSize,
        fileMeta: { content: "", contentType: file.contentType },
      })),
      isWint: comment.fromWint,
    })) ?? []
  );
}
